module.exports = __webpack_public_path__ + "img/logo-aldrive.cadc7ba9.png";